enum ReminderStatus {
  SENT = 'Sent',
  PENDING = 'Pending',
  DISABLE = 'Disable',
  ENABLE = 'Enable',
}

export default ReminderStatus;
